import React from 'react';
import Firebase from 'firebase';
import ClientsItem from './clientsItem'
import { Tooltip, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


var ReactToastr = require("react-toastr");
var { ToastContainer } = ReactToastr;
var ToastMessageFactory = React.createFactory(ReactToastr.ToastMessage.animation);

export default class clientsConfig extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
        this.newClient = this.newClient.bind(this);
        this.sendClient = this.sendClient.bind(this);
    }

    componentWillMount() {
        var clientsRef = Firebase.database().ref("clients");
        clientsRef.on("value", snap => {
            this.setState({ clients: snap.val() })
        })
    }

    newClient() {
        return (
            <div className="card">
                <div className="card-block">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Identificador:</label>
                                <input type="text" className="form-control" id="name" value={this.state.id} onChange={(e) => this.setState({ id: e.target.value })} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Nombre:</label>
                                <input type="text" className="form-control" id="name" value={this.state.name} onChange={(e) => this.setState({ name: e.target.value })} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    sendClient() {
        var clientsRef = Firebase.database().ref("clients");
        clientsRef.child(this.state.id).set({
            name: this.state.name
        }).then(resp => {
            this.refs.container.success(
                "NUEVO CLIENTE",
                "El cliente " + this.state.name + "fue añadido", {
                    timeOut: 3000,
                    extendedTimeOut: 10000
                });
            this.setState({ showModal: false })

        })
    }

    render() {
        return (
            <div className="card">
                <ToastContainer ref="container"
                    style={{ top: "60px" }}
                    toastMessageFactory={ToastMessageFactory}
                    className="toast-top-right"
                />
                <div className="card-header">
                    <span><i className="fa fa-align-left"></i> Listado de clientes</span>
                    <span style={{ right: "15px", position: "absolute", cursor: "pointer" }} onClick={() => this.setState({ showModal: true })}>Nuevo Cliente <i className="fa fa-plus"></i></span>
                </div>
                <div className="card-block">
                    <table className="table table-hover table-outline mb-0 hidden-sm-down">
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Número de formularios</th>
                                <th>Número de locales</th>
                                <th>Número de usuarios</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.clients ?
                                Object.values(this.state.clients).map((c, index) => (
                                    <ClientsItem
                                        key={index}
                                        client={c}
                                        clientId={Object.keys(this.state.clients)[index]}
                                        verComo={() => {
                                            this.refs.container.success(
                                                "Visualización de cliente actualizada",
                                                "Vista de cliente", {
                                                    timeOut: 3000,
                                                    extendedTimeOut: 10000
                                                }
                                            )
                                        }} />
                                ))
                                :
                                ""
                            }

                        </tbody>
                    </table>
                </div>
                <Modal isOpen={this.state.showModal} toggle={() => { this.setState({ showModal: false }) }} className="showModal-dialog showModal-lg">
                    <ModalHeader toggle={() => { this.setState({ showModal: false }) }}>
                    </ModalHeader>
                    <ModalBody>
                        {this.newClient()}
                    </ModalBody>
                    <ModalFooter>
                        <button onClick={() => this.sendClient()} type="button" className="btn btn-outline-success">Guardar</button>{' '}
                        <button onClick={() => { this.setState({ showModal: false }) }} type="button" className="btn btn-outline-warning">Cancelar</button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/administracion/clients/clientsConfig.js